import List from '@/pages/admin/locations/List.vue';
import Show from '@/pages/admin/locations/Show.vue';
import handleActivePaginationRouteProps from '@/utils/handleActivePaginationRouteProps.js';

export default [
  {
    path: 'locations',
    name: 'locations',
    component: List,
    props: handleActivePaginationRouteProps,
  },
  {
    path: 'locations/:id(\\d+)',
    name: 'location',
    component: Show,
  },
];
